import { useMutation, useQuery } from "@apollo/client/react";

import { Place } from '../../models/place'
import { useGroups } from '../../models/ingredientGroup'

import { PlacesView } from './PlacesView'

export const PlacesContainer = (props) => {
  const { data, loading } = useQuery(Place.fetch)
  const collection = data && data.collection

  const [ groups ] = useGroups()

  Place.usePlaceUpdate()
  Place.usePlaceDeleted()
  const [ placeUpdate ] = useMutation(Place.update)
  const [ placeDelete ] = Place.usePlaceDelete()

  const handlePlaceUpdate = doc => {
    placeUpdate({
      variables: {
        input: doc
      }
    })
  }

  const handlePlaceDelete = ({ id }) => {
    placeDelete({
      variables: { id }
    })
  }

  const handleOrderChange = (place, groupOrder) => {
    placeUpdate({
      variables: {
        input: {
          id: place.id,
          groupOrder
        }
      },
      // Instant reorder: don't wait for the round trip
      optimisticResponse: {
        placeUpdate: {
          __typename: 'Place',
          id: place.id,
          createdAt: place.createdAt,
          name: place.name,
          groupOrder,
          hiddenGroups: place.hiddenGroups || []
        }
      }
    })
  }

  const handleHiddenChange = (place, hiddenGroups) => {
    placeUpdate({
      variables: {
        input: {
          id: place.id,
          hiddenGroups
        }
      },
      optimisticResponse: {
        placeUpdate: {
          __typename: 'Place',
          id: place.id,
          createdAt: place.createdAt,
          name: place.name,
          groupOrder: place.groupOrder || [],
          hiddenGroups
        }
      }
    })
  }

  if (!loading) {
    return (
      <PlacesView
        {...props}
        collection={collection}
        groups={groups}
        onPlaceUpdate={handlePlaceUpdate}
        onPlaceDelete={handlePlaceDelete}
        onOrderChange={handleOrderChange}
        onHiddenChange={handleHiddenChange}
      />
    )
  } else
    return null
}
